import { create } from 'zustand';
import {
  DEFAULT_LANGUAGE,
  getLanguageLocale,
  type SupportedLanguageCode,
} from '../config';
import { readLanguagePreference, writeLanguagePreference } from '../preference';

export const resolveInitialLanguage = (): SupportedLanguageCode =>
  readLanguagePreference() ?? DEFAULT_LANGUAGE;

const applyLanguage = (language: SupportedLanguageCode) => {
  const locale = getLanguageLocale(language);

  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('lang', locale);
  }

  if (typeof window !== 'undefined') {
    window.dispatchEvent(
      new CustomEvent('shell-language-change', {
        detail: {
          code: language,
          locale,
        },
      })
    );
  }
};

interface LanguageStore {
  language: SupportedLanguageCode;
  setLanguage: (language: SupportedLanguageCode) => void;
}

export const useLanguageStore = create<LanguageStore>((set) => ({
  language: resolveInitialLanguage(),

  setLanguage: (language) => {
    writeLanguagePreference(language);
    applyLanguage(language);
    set({ language });
  },
}));

if (typeof window !== 'undefined') {
  applyLanguage(useLanguageStore.getState().language);
}

export type { SupportedLanguageCode };
export default useLanguageStore;
